module.exports = __webpack_public_path__ + "img/parker-westport-logo.d20275df.png";